import { memo } from 'react';
import { cx, css } from '@emotion/css';
import { Trophy as ProgressIcon, Check as CompletedIcon } from '@phosphor-icons/react';

import cn from './progressIndicator.module.scss';

//[Link to Figma](https://www.figma.com/design/haLJY8Z5UGGqIbRajgg9GP/Design-system?node-id=1149-43377&t=WmeJ6bnkXd1frRO2-0)

type ProgressProps = {
    progress: number;
    className?: string;
    size?: 'small' | 'big';
    showProgressIcon?: boolean;
    showComplete?: boolean;
    showPercent?: boolean;
}

const ProgressIndicator = ({ className, size = 'small', progress, showProgressIcon = true, showComplete = false, showPercent = true }: ProgressProps) => {
    const _cssProgress = css({
        width: `${progress}%`
    });

    return (
        <div className={cx(cn.container, className)}>
            {showPercent && <div className={cx(cn.label, cn[size], 'progress__label')}>
                <strong>{progress}%</strong>
            </div>}
            <div className={cx(cn.rule, cn[size], 'progress__rule')}>
                {progress > 0 && <span className={cx(cn.progress, _cssProgress, 'progress__progress')} />}
            </div>
            {showProgressIcon && <ProgressIcon className={cx(cn.ico, 'progress__ico')} />}
            {showComplete && (progress >= 100) && <CompletedIcon size={14} className={cx(cn.completed, 'progress__text__completed')} />}
        </div>
    );

};

export default memo(ProgressIndicator);
